export default {
  namespaced: true,
  state: {
    focusedEssayInput: null,
    focusedInputTarget: null,
    lessonData: null,
  },

  getters: {
    isTargetFocused: state => !!state.focusedInputTarget,
  },

  mutations: {
    SET_FOCUSED_ESSAY_INPUT(state, input) {
      state.focusedEssayInput = input
    },
    SET_FOCUSED_ESSAY_INPUT_TARGET(state, input) {
      state.focusedInputTarget = input
    },
    SET_LESSON_DATA(state, input) {
      state.lessonData = input
    },
  },

  actions: {
    setFocusedEssayInput({ commit }, input) {
      commit('SET_FOCUSED_ESSAY_INPUT', input.name)
      commit('SET_FOCUSED_ESSAY_INPUT_TARGET', input.target)
    },
    setLessonData({ commit }, input) {
      commit('SET_LESSON_DATA', input)
    },
  },
}
